import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromJobCard from './+state/job-card.reducer';
import { JobCardEffects } from './+state/job-card.effects';
import { JobCardFacade } from './+state/job-card.facade';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromJobCard.JOB_CARD_FEATURE_KEY,
      fromJobCard.reducer
    ),
    EffectsModule.forFeature([JobCardEffects]),
    MatSnackBarModule,
    MatDialogModule,
    HttpClientModule,
  ],
  providers: [JobCardFacade],
})
export class JobCardDataAccessModule {}
